/* eslint-disable array-callback-return */

import { Card, CardContent, Tooltip, withStyles, withTheme } from '@material-ui/core';
import { Box, Typography } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  DELETE_CLIENT_CUSTOM_FIELD_FAILURE,
  GET_CLIENT_CUSTOM_FIELDS_FAILURE,
  POST_CLIENT_CUSTOM_FIELD_FAILURE,
  UPDATE_CLIENT_CUSTOM_FIELD_FAILURE
} from '../../types';
import { deleteCustomField, postClientCustomField, updateClientCustomField, getClientCustomFields } from '../../clients.actions';
import CrudTable from '../crudTable.component';
import { getEnumColumns } from 'modules/common/enumTableColumn';

const styles = theme => {
  return {
    row: {
      backgroundColor: theme.palette.common.white
    },
    accordionStyleContacts: {
      maxWidth: 1050
    },
    inputGroup: {
      display: 'inline-flex',
      justifyContent: 'space-between'
    },
    root: {
      maxWidth: 170,
      marginRight: 10
    },
    extRoot: {
      width: 115,
      marginRight: 10
    },
    primaryText: {
      paddingTop: 2,
      paddingRight: 5,
      marginRight: 16
    },
    newRow: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1050
    }
  };
};

const ClientCustomFieldsTable = props => {
  const { clientCustomFields, clientRecordId, enumerations, divisions, policies } = props;
  
  const [customFields, setCustomFields] = useState(
    clientCustomFields && clientCustomFields.length > 0 ? clientCustomFields.filter(s => s.clientCustomFieldId !== null) : []
  );
  const [purposeBuiltFields, setPurposeBuiltFields] = useState(
    clientCustomFields && clientCustomFields.length > 0 ? clientCustomFields.filter(s => s.purposeBuiltFieldId === null) : []
  );

  const fieldStatuses =
    enumerations.fieldStatuses && enumerations.fieldStatuses.length > 0
      ? enumerations.fieldStatuses.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const fieldTypes =
    enumerations.fieldTypes && enumerations.fieldTypes.length > 0
      ? enumerations.fieldTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const { fieldStatusColumn, fieldTypeColumn } = getEnumColumns(enumerations);

  const fieldDependencyOperations = 
    enumerations.surveyTriggerTypes && enumerations.surveyTriggerTypes.length > 0
      ? enumerations.surveyTriggerTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const mapDependencyValueToOption = value => {
    const id = value?.id ?? value?.clientDivisionId ?? value?.policy?.relocationPolicyId ?? value?.policy?.policyId;
    const title = value?.title ?? value?.divisionName ?? value?.policy?.policyDescription ?? value?.name;

    if (id === undefined || id === null) {
      return null;
    }

    return {
      id,
      title: title || ''
    };
  };

  const fieldDependencyValues = [
    { id: '0', values: divisions || [] },
    { id: '1', values: policies || [] },
    { id: '2', values: [] }
  ];

  const generateFieldDependencyOptions = () => {
    let dependencyOptions = [{ id: '0', title: 'Division' },
      { id: '1', title: 'Relocation Policy' }];
    if(purposeBuiltFields && purposeBuiltFields.length > 0)
    {
     purposeBuiltFields.map(f => {
        let newValue = {
          id: String(dependencyOptions.length),
          title: f.fieldLabel
        };
        dependencyOptions.push(newValue);
      });
      
    }
    if(customFields && customFields.length > 0)
    {
      customFields.map(f => {
        let newValue = {
          id: String(dependencyOptions.length),
          title: f.fieldLabel
        };
        dependencyOptions.push(newValue);
      });
    }

    return dependencyOptions;
  };

    const fieldDepdendencies = generateFieldDependencyOptions();

  const getFieldDependencyValueOptions = fieldDependentOnId => {
    const normalizedId = String(fieldDependentOnId);
    const selectedDependency =
      normalizedId === '0' || normalizedId === '1'
        ? fieldDependencyValues.find(option => String(option.id) === normalizedId)
        : fieldDependencyValues.find(option => String(option.id) === '2');

    if (!selectedDependency || !Array.isArray(selectedDependency.values)) {
      return [];
    }

    return selectedDependency.values.map(mapDependencyValueToOption).filter(Boolean);
  };

  // const getFieldDependencyValueNames = (values, fieldDependencyValueId) => {
  //   const selectedValue = values?.find(v => v.id === fieldDependencyValueId);
  //   return selectedValue ? selectedValue.title : '';
  // };

  const mapFieldDependencies = dependencies => {
    return dependencies.map(d => ({
      dependencyId: d.dependencyId,
      customFieldId: d.customFieldId,
      fieldDependentOnId: fieldDepdendencies.find(f => f.title === d.fieldDependentOnId)?.id,
      fieldDependentOnOperationId: d.fieldDependentOnOperationId,
      fieldDependentOnValueId: d.fieldDependentOnValueId,
      resultingListValues: d.resultingListValues,
      isMakeRequired: d.isMakeRequired,
      modifiedBy: d.modifiedBy,
      modifiedOn: d.modifiedOn
    }));
  };

  let mappedCustomFields = customFields && customFields.length > 0 ? customFields.map(s => ({
    customFieldCommonId: s.customFieldCommonId,
    fieldId: s.fieldId || (customFields && customFields.length > 1 ? 'CustomField' + customFields.length : 'CustomField1'),
    fieldLabel: s.fieldLabel,
    fieldTypeId: s.fieldTypeId,
    fieldStatusId: s.fieldStatusId,
    isRequiredField: s.isRequiredField,
    isRequiredOnClientAuthForm: s.isRequiredOnClientAuthForm,
    isRequiredOnIntakeForm: s.isRequiredOnIntakeForm,
    isRequiredOnInvoice: s.isRequiredOnInvoice,
    isRequiredOnPayroll: s.isRequiredOnPayroll,
    fieldListValues: s.fieldListValues,
    fieldNotes: s.fieldNotes,
    fieldDependencies: mapFieldDependencies(s.customFieldDependencies)
  })) : [];

  const formLabel = 'Dependencies';
  const triggerHeader = { title: 'Dependencies', hint: 'Custom field dependencies will dictate when a custom field is displayed to a user. You may also update a list of values and when the field is required based on entered dependencies.' };
  const createNewCustomDependencyRowFunc = () => {
    return {
      fieldDependentOnId: '',
      fieldDependentOnValueId: '',
      fieldDependentOnOperationId: '98ba1156-a956-45db-9d68-10f2e345b7f9',
      isMakeRequired: false,
      resultingListValues: '',
      categoryType: 'customDependency'
    };
  };

    const customDependencyFormFields = [
      {
        name: 'dependencyId',
        type: 'hidden'
      },
      {
        name: 'customFieldId',
        type: 'hidden'
      }, 
      {
      name: 'fieldDependentOnId',
      type: 'dropdown-v2',
      options: fieldDepdendencies,
      label: 'Field Name',
      },
      {
        name: 'fieldDependentOnOperationId',
        type: 'dropdown-v2',
        options: fieldDependencyOperations || [],
        label: 'Operation',
      },
    {
      name: 'fieldDependentOnValueId',
      type: 'dependency-value',
      options: rowValues => getFieldDependencyValueOptions(rowValues.fieldDependentOnId),
      label: 'Field Value',
      },
    {
      name: 'resultingListValues',
      type: 'text',
      label: 'Resulting List Values',
      dependentOn: 'fieldTypeId',
      dependentValue: '5abfc239-5144-4155-91c2-68a71755f995',
      hint: 'Separate values with a semicolon'
    },
    { name: 'isMakeRequired', type: 'checkbox', label: 'Make Field Required When Value Matches' }
  ];

  const adjustedColumns = [
    {
      accessorKey: 'fieldId',
      header: 'Field ID',
      type: 'text',
      required: false,
      size: 150,
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false,
      hint: 'This is a system generated field and cannot be changed. The field ID will be automatically generated.'
    },
    {
      accessorKey: 'fieldLabel',
      header: 'Label',
      type: 'text',
      required: true,
      size: 150,
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false
    },
    {
      ...fieldTypeColumn('fieldTypeId'),
      header: 'Type',
      type: 'dropdown-v2',
      options: fieldTypes,
      required: true,
      size: 70,
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false
    },
    {
      ...fieldStatusColumn('fieldStatusId'),
      header: 'In Use',
      type: 'dropdown-v2',
      options: fieldStatuses,
      size: 70,
      required: true,
      enableColumnDragging: false,
      enableResizing: false
    },
    {
      accessorKey: 'isRequiredField',
      header: 'Required',
      type: 'checkbox',
      enableColumnDragging: false,
      size: 70,
      Cell: ({ cell }) =>
        cell.row.original.isRequiredField != null && cell.row.original.isRequiredField === true ? <p>Yes</p> : <p>No</p>,
      enableColumnActions: false,
      enableResizing: false
    },
    {
      accessorKey: 'isRequiredOnClientAuthForm',
      header: 'Is Required on Client Auth Form',
      type: 'checkbox',
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false,
      hideInTable: true
    },
    {
      accessorKey: 'isRequiredOnIntakeForm',
      header: 'Is Required on Intake Form',
      type: 'checkbox',
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false,
      hideInTable: true
    },
    {
      accessorKey: 'isRequiredOnInvoice',
      header: 'Is Required on Invoice',
      type: 'checkbox',
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false,
      hideInTable: true
    },
    {
      accessorKey: 'isRequiredOnPayroll',
      header: 'Is Required on Payroll',
      type: 'checkbox',
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false,
      hideInTable: true
    },
    {
      accessorKey: 'fieldListValues',
      header: 'Field List Values',
      type: 'notes',
      dependentOn: 'fieldTypeId',
      dependentValue: '5abfc239-5144-4155-91c2-68a71755f995',
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false,
      hideInTable: true,
      hint: 'Separate values with a semicolon'
    },
    {
      accessorKey: 'fieldNotes',
      header: 'Field Notes',
      type: 'notes',
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false,
      hideInTable: true
    },
    { accessorKey: 'fieldDependencies', 
      header: triggerHeader, 
      type: 'multi-row-form', 
      addRowLabel: 'Add Dependency', 
      formLabel: formLabel, 
      formFields: customDependencyFormFields, 
      required: false, 
      createNewRowFunc: createNewCustomDependencyRowFunc,
      size: 100, 
      hideInTable: true, 
    }
    // {
    //   accessorKey: 'isFieldDependentOn',
    //   header: 'Dependent',
    //   defaultVal: false,
    //   type: 'checkbox',
    //   enableColumnDragging: false,
    //   enableColumnActions: false,
    //   enableResizing: false,
    //   hideInTable: true
    // },
    // {
    //   accessorKey: 'fieldDependentOnId',
    //   header: 'Field Dependent On',
    //   type: 'dropdown-v2',
    //   dependentOn: 'isFieldDependentOn',
    //   dependentValue: true,
    //   options: fieldDepdendencies,
    //   enableColumnDragging: false,
    //   enableColumnActions: false,
    //   enableResizing: false,
    //   hideInTable: true
    // },
    // {
    //   accessorKey: 'fieldDependentOnValueId',
    //   header: 'Field Dependent On Value',
    //   type: 'dropdown-v2',
    //   dependentOn: 'isFieldDependentOn',
    //   dependentValue: true,
    //   options: fieldDepdendencyValues,
    //   enableColumnDragging: false,
    //   enableColumnActions: false,
    //   enableResizing: false,
    //   hideInTable: true
    // }
  ];

  const updateRow = async (field, values) => {
    const customFieldId = field.original.customFieldCommonId;
    const id = field.original.clientCustomFieldId;
    let fieldId =
      customFields && Array.isArray(customFields) ? customFields.find(s => s.customFieldCommonId === customFieldId)?.fieldId : null;

    // if (fieldId === null || fieldId === '') {
    //   fieldId = customFields && customFields.length > 1 ? 'CustomField' + customFields.length : 'CustomField1';
    // }

    let dependencies = [];

    if (values.fieldDependencies) {
      values.fieldDependencies.forEach(d => {
          const resolvedCustomFieldId = d.customFieldId ?? customFieldId ?? 0;
          let newValue = {
            dependencyId: d.dependencyId,
            customFieldId: resolvedCustomFieldId,
            fieldDependentOnId: fieldDepdendencies.find(f => f.id === d.fieldDependentOnId)?.title,
            fieldDependentOnOperationId: d.fieldDependentOnOperationId,
            fieldDependentOnValueId:
              d.fieldDependentOnValueId && Array.isArray(d.fieldDependentOnValueId)
                ? d.fieldDependentOnValueId
                    .map(value => value?.title)
                    .filter(Boolean)
                    .join(';')
                : d.fieldDependentOnValueId,
            resultingListValues: d.resultingListValues,
            isMakeRequired: d.isMakeRequired,
            modifiedBy: 1,
            modifiedOn: new Date()
          };
          dependencies.push(newValue);
      });
    }

    let newValues = {
      purposeBuiltFieldId: null,
      clientCustomFieldId: id,
      customFieldCommonId: customFieldId,
      clientRecordId: clientRecordId,
      fieldId: fieldId,
      fieldLabel: values.fieldLabel,
      fieldTypeId: values.fieldTypeId,
      fieldStatusId: values.fieldStatusId,
      isRequiredField: values.isRequiredField,
      isRequiredOnClientAuthForm: values.isRequiredOnClientAuthForm,
      isRequiredOnIntakeForm: values.isRequiredOnIntakeForm,
      isRequiredOnPayroll: values.isRequiredOnPayroll,
      fieldListValues: values.fieldListValues,
      fieldNotes: values.fieldNotes,
      // isFieldDependentOn: values.isFieldDependentOn,
      // fieldDependentOnId: values.fieldDependentOnId,
      // fieldDependentOnValueId: values.fieldDependentOnValueId,
      customFieldDependencies: dependencies,
      // customFieldDivisions: filteredDivisions,
      modifiedBy: 1,
      modifiedOn: new Date()
    };

    const resp = await props.updateClientCustomField(newValues);
    if (resp.type === UPDATE_CLIENT_CUSTOM_FIELD_FAILURE) {
      return false;
    } else {
      const getResp = await props.getClientCustomFields(clientRecordId);
      if (getResp.type === GET_CLIENT_CUSTOM_FIELDS_FAILURE) {
        return false;
      } else {
        setCustomFields(getResp.response.filter(s => s.clientCustomFieldId !== null));
        setPurposeBuiltFields(getResp.response.filter(s => s.purposeBuiltFieldId !== null));
        return true;
      }
    }
  };

  const createRow = async values => {

    let dependencies = [];

    if (values.fieldDependencies) {
      values.fieldDependencies.forEach(d => {
          const resolvedCustomFieldId = d.customFieldId ?? 0;
          let newValue = {
            dependencyId: d.dependencyId,
            customFieldId: resolvedCustomFieldId,
            fieldDependentOnId: fieldDepdendencies.find(f => f.id === d.fieldDependentOnId)?.title,
            fieldDependentOnOperationId: d.fieldDependentOnOperationId,
            fieldDependentOnValueId:
              d.fieldDependentOnValueId && Array.isArray(d.fieldDependentOnValueId)
                ? d.fieldDependentOnValueId
                    .map(value => value?.title)
                    .filter(Boolean)
                    .join(';')
                : d.fieldDependentOnValueId,
            resultingListValues: d.resultingListValues,
            isMakeRequired: d.isMakeRequired,
            modifiedBy: 1,
            modifiedOn: new Date()
          };
          dependencies.push(newValue);
      });
    }

    let newValues = {
      clientRecordId: clientRecordId,
      fieldId: customFields && customFields.length > 1 ? 'CustomField' + customFields.length : 'CustomField1',
      fieldLabel: values.fieldLabel,
      fieldTypeId: values.fieldTypeId,
      fieldStatusId: values.fieldStatusId,
      isRequiredField: values.isRequiredField ? values.isRequiredField : false,
      isRequiredOnClientAuthForm: values.isRequiredOnClientAuthForm ? values.isRequiredOnClientAuthForm : false,
      isRequiredOnIntakeForm: values.isRequiredOnIntakeForm ? values.isRequiredOnIntakeForm : false,
      isRequiredOnInvoice: values.isRequiredOnInvoice ? values.isRequiredOnInvoice : false,
      isRequiredOnPayroll: values.isRequiredOnPayroll ? values.isRequiredOnPayroll : false,
      fieldListValues: values.fieldListValues,
      fieldNotes: values.fieldNotes,
      // isFieldDependentOn: values.isFieldDependentOn ? values.isFieldDependentOn : false,
      // fieldDependentOnId: values.fieldDependentOnId ? values.fieldDependentOnId : '00000000-0000-0000-0000-000000000000',
      // fieldDependentOnValueId: values.fieldDependentOnValueId ? values.fieldDependentOnValueId : '00000000-0000-0000-0000-000000000000',
      customFieldDependencies: dependencies,
      addedBy: 1,
      addedOn: new Date(),
      modifiedBy: 1,
      modifiedOn: new Date()
    };

    const resp = await props.postClientCustomField(newValues);
    if (resp.type === POST_CLIENT_CUSTOM_FIELD_FAILURE) {
      return false;
    } else {
      const getResp = await props.getClientCustomFields(clientRecordId);
      if (getResp.type === GET_CLIENT_CUSTOM_FIELDS_FAILURE) {
        return false;
      } else {
        setCustomFields(getResp.response.filter(s => s.clientCustomFieldId !== null));
        setPurposeBuiltFields(getResp.response.filter(s => s.purposeBuiltFieldId !== null));
        return true;
      }
    }
  };

  const deleteRow = async field => {
    const id = field.original.customFieldCommonId;
    const resp = await props.deleteCustomField(id);
    if (resp.type === DELETE_CLIENT_CUSTOM_FIELD_FAILURE) {
      return false;
    } else {
      const getResp = await props.getClientCustomFields(clientRecordId);
      if (getResp.type === GET_CLIENT_CUSTOM_FIELDS_FAILURE) {
        return false;
      } else {
        setCustomFields(getResp.response.filter(s => s.clientCustomFieldId !== null));
        setPurposeBuiltFields(getResp.response.filter(s => s.purposeBuiltFieldId !== null));
        return true;
      }
    }
  };

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Tooltip title={'File Contract'} key={'clientDivisions'} placement="right">
            <FontAwesomeIcon icon={['fas', 'location-dot']} size="2x" />
          </Tooltip>
          <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
            Transferee Data - Custom Fields
          </Typography>
          <div className={props.classes.mb2}>
            <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '16px', marginLeft: '24px' }}>
              Unused Custom Fields:{' '}
            </Typography>
            <Typography variant="subtitle2" sx={{ color: 'green', fontWeight: 'bold', fontSize: '16px', marginLeft: '24px' }}>
              {customFields ? 20 - customFields.length : 0}{' '}
            </Typography>
          </div>
        </Box>
        <CrudTable
          editingMode={'modal'} // Can be changed to 'row' to edit inline
          columns={adjustedColumns}
          rows={mappedCustomFields ? mappedCustomFields : []}
          updateRow={updateRow}
          createRow={createRow}
          deleteRow={deleteRow}
          hideEdit={props.hideEdit}
          hideAdd={props.hideEdit || (mappedCustomFields && mappedCustomFields.length >= 20)}
        />
      </CardContent>
    </Card>
  );
};

ClientCustomFieldsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  clientRecordId: PropTypes.number,
  formikProps: PropTypes.object.isRequired,
  internalUsers: PropTypes.array,
  clientCustomFields: PropTypes.array
};

const mapStateToProps = state => {
  const { clientContactsLoading } = state.clients;
  return {
    clientContactsLoading
  };
};

export default compose(
  withStyles(styles),
  withTheme,
  connect(mapStateToProps, {
    getClientCustomFields,
    postClientCustomField,
    updateClientCustomField,
    deleteCustomField
  })
)(ClientCustomFieldsTable);
